import { Observable } from 'rxjs/Observable';
import { EventSource } from './eventSource';


import 'rxjs/add/observable/interval'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/switchMap'

import { nullSorter } from './sort';
import { Photo } from './eventSource';

export type Registry = {
  url: string;
  name: string;
  key: string;
  logoUrl: string;
}

export interface EventRegistryData {
  stores: Registry[];
  note: string | null;
  primaryPhotoHorizontal: Photo,
}

export class EventRegistry {

    private es: EventSource;

    constructor(eventSource: EventSource) {
        this.es = eventSource;
    }
    
    public observeStores(): Observable<Registry[]> {
      return this.es.pluckData(this.es.observeRegistryPage(), ['stores'])
        .map(stores => Object.keys(stores).map((key, idx) => {
          stores[key].key = key;
          stores[key].sortKey = (stores[key].sortKey && !isNaN(parseInt(stores[key].sortKey))) ? parseInt(stores[key].sortKey) : idx;
          return stores[key];
        }).filter(x => x)).map(data => data.sort(nullSorter));
    }

    public observeRegistryNote(): Observable<string> {
      return this.es.pluckData(this.es.observeRegistryPage(), ['note']);
    }

    public observeRegistryPhoto(): Observable<Photo> {
      return this.es.pluckData(this.es.observeRegistryPage(), ['primaryPhotoHorizontal']);
    }

    public observeRegistry(): Observable<EventRegistryData> {
      return Observable.combineLatest(
        this.observeStores(),
        this.observeRegistryNote(),
        this.observeRegistryPhoto(),
        (stores, note, photo) => {
        note = typeof note === 'string' && note || null;
        return ({
          stores,
          note,
          primaryPhotoHorizontal: photo,
        })
      });
    }
}
